<header class="header"></header>
<div class="container-gray isBackgoround">
  <main>
    <div class="v-application v-application--is-ltr theme--light main">
      <img
        src="/assets/collabo-portal/images/check.svg"
        width="100"
        height="100"
        alt="チェック"
        class="mb-6"
      />
      <h2 class="text-h6 font-weight-bold text-center mb-6">
        パスワードが変更されました
      </h2>
      <p class="text-caption text-subtitle-1 text-center mb-6">
        パスワードの変更が完了しました。<br />
        以下のリンクより、各システムへアクセスしログインください。
      </p>
      <a [href]="dxSalesLink" class="text-link v-text-caption mb-4"
        >登録支援システム</a
      >
      <a [href]="sgzpApp4Link" class="text-link v-text-caption mb-4"
        >処方元情報連携システム</a
      >
    </div>
  </main>
</div>
